(function () {
  const SELECTORS = [
    '.price',
    '.price-item',
    '.unit-price',
    '.product__info-container',
    '.product-form',
    '.sls',
    '[data-seal-subscriptions]',
    '.seal-subscriptions',
    '.sealapp-container',
    '.seal-app-container',
    '[class*="seal"]'
  ];

  function replaceTextInNode(root) {
    if (!root) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    let node;

    while ((node = walker.nextNode())) {
      const v = node.nodeValue;
      if (!v) continue;

      const replaced = v
        .replace(/\s*\/\s*ITEMS?\b/g, ' / Stück')
        .replace(/\s*\/\s*items?\b/g, ' / Stück')
        .replace(/\s*\/\s*item\b/g, ' / Stück');

      if (replaced !== v) node.nodeValue = replaced;
    }
  }

  function runOnce() {
    SELECTORS.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el) => replaceTextInNode(el));
    });
  }

  function observe() {
    const obs = new MutationObserver(() => {
      runOnce();
    });

    obs.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true
    });
  }

  function boot() {
    runOnce();
    setTimeout(runOnce, 300);
    setTimeout(runOnce, 800);
    setTimeout(runOnce, 1500);
    setTimeout(runOnce, 2500);
    setTimeout(runOnce, 4000);

    document.addEventListener('variant:change', runOnce);
    document.addEventListener('product:variant-change', runOnce);

    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();